import DisplayView from '../../../../../components/DisplayView';
import SearchSimple from '../../../../../components/SearchSimples/SearchSimple';
import {permissionObj} from '../../../../../Helpers/permission';
import {CustomCheckbox} from '../../../../../components/CustomCheckbox';
import {CustomCardGrid} from '../../../../../components/CustomCardGrid';
import {status} from '../../../../../enums/statusEnum';
import {statusBorderColor, statusColor, statusFontColor} from '../../../../../enums/statusColorEnum';
import ButtonActionsCard from '../../../../../components/buttons/ButtonActionsCard';
import {
    ArrowRightIcon,
    EmailSubsectionChip,
    PhoneSubsectionChip
} from '../../../../../components/buttons/IconButtons';

import  IconPersonDefault  from '../../../../../assets/ImagesDefaults/ic-person-v2.svg';
import {EMPTY_VALUES} from '../../../../../Apis/functions';
import NotInformation from '../../../../../components/NotInformation';
import React from 'react';
import ContractorCardsApp from '../../Functionality/ContractorCardsApp';
import CustomTooltip from '../../../../../components/CustomTooltip';
import CustomChip from '../../../../../components/CustomChip';
import {getViewTypeByName} from '../../../../../enums/ViewType';
import {colors} from '../../../../../enums/colors';
import routes from '../../../../../Routes/routes';
import {TABS_CONTRACTORS} from '../../Model/Models';
import CustomButtonLink from '../../../../../components/buttons/CustomButtonLink';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const ContractorsCards = (props) => {

    const {
        contractorId,
        selectedList,
        setSelectedList,
        searchElement,
        setSearchElement,
        isAllChecked,
        setIsAllChecked,
        setBodyForExport,
        search,
        setSearch,
        setSimpleSearch,
        supplierId,
        view,
        setView,
        modified,
        setModified,
        finalArray,
        setCriteria,
    } = props;


    const {
        DEV,
        permission,
        t, // Translation function
        navigate,
        elementRefTable,
        results,
        pagination,
        handleCheckboxChange,
        handleDeleteAll,
        setResults,
        option,
        rowsPerPage
    } = ContractorCardsApp({
        searchElement,
        setSearchElement,
        contractorId,
        modified,
        setModified,
        finalArray,
        setCriteria,
        setIsAllChecked,
        selectedList,
        setSelectedList,
        search,
        setSearch,
        setBodyForExport
    });

    return (
        <>
            <div className={"d-flex"}>
                <DisplayView view={view} setView={setView} left={0} />
                <div className={"ml-2 w-100"}>
                    <SearchSimple
                        id={"txt_cc_search_cards"}
                        setBodyForExport={setBodyForExport}
                        setSearchResults={setResults}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        rowsPerPage={rowsPerPage}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        contractorId={contractorId}
                        supplierId={supplierId}
                        viewType={getViewTypeByName(view)}
                    />
                </div>
            </div>
            {
                results?.content?.length > 0 ?
                    <>
                        {(contractorId === null && (DEV || permission.includes(permissionObj?.WEB_CONTRACTOR_DELETE))) && (
                            <div className={"col-12 p-0"}>
                                <CustomCheckbox
                                    id={"cb_cc_de_select_all"}
                                    trans={t('de_/_select_all')}
                                    checked={isAllChecked}
                                    onChange={handleDeleteAll}
                                />
                            </div>
                        )}
                        <div className={"col-12 p-0"} >
                            <div className='panelTables px-1' ref={elementRefTable}>
                                <div className={"row"}>
                                    {results?.content?.map((item, index) => {
                                        const showButton = DEV || permission?.includes(permissionObj?.WEB_CONTRACTOR_UPDATE);

                                        return (
                                            <CustomCardGrid
                                                key={"cb_cc_row_"+index}
                                                classNamePanelGrid='col-12 col-sm-3 px-0 pr-1 mb-3'
                                                itemId={item?.id}
                                                checkboxId={"cb_cc_row_"+item?.id}
                                                checked={selectedList?.includes(item?.id)}
                                                onCheckboxChange={handleCheckboxChange}
                                                disabled={false}
                                                statusColor={statusColor[item?.statusId]}
                                                statusName={t(status[item?.statusId])}
                                                fontColor={statusFontColor[item?.statusId]}
                                                borderColor={statusBorderColor[item?.statusId]}
                                                chipVariant="large"
                                                isCheckboxShow={contractorId === null && (DEV || permission.includes(permissionObj?.WEB_CONTRACTOR_CONTRACT_DELETE))}
                                                backgroundImage={item?.selfie != null ? `data:image/png;base64,${item?.selfie}` : ''}
                                                srcImage={item?.selfie != null ? `data:image/png;base64,${item?.selfie}` : IconPersonDefault}
                                                btnActions={ showButton &&
                                                    <ButtonActionsCard
                                                        id={`btn_cc_actions_card_${index + 1}`}
                                                        name={'update'}
                                                        Icon={ArrowRightIcon}
                                                        onClick={() => {
                                                            navigate(routes.contractor.update +  item?.id,
                                                                { state: {
                                                                        backUrl: routes.contractor.list,
                                                                        currentTab: TABS_CONTRACTORS.CONTRACTORS.INDEX,
                                                                    }
                                                                }
                                                            );
                                                        }}
                                                    />
                                                }
                                                height={''}
                                            >
                                                <div className="px-2">
                                                    <div className="justify-content-center align-items-center">
                                                        <CustomTooltip
                                                            text={item.fullName}
                                                            classes={"ibl-h3 font-color-general-950 ibl-font-w-600 text-center text-ellipsis-2-rows"}
                                                            showIfTruncated={true}
                                                            placement={"top"}
                                                        />
                                                    </div>

                                                    <div className="d-flex justify-content-center align-items-center mt-2">
                                                        <CustomChip legend={item?.acronym || EMPTY_VALUES.DEFAULT}
                                                                    background={colors.secondary100}
                                                                    fontColor={colors.secondary700}
                                                                    borderColor={colors.secondary150}
                                                        />
                                                    </div>


                                                    <div className={"border-bottom-shades-300-2px my-3"}/>

                                                    <div className="row d-flex justify-content-center align-items-center">
                                                        <div className="col-6 pl-0">
                                                            <div className="d-flex justify-content-start align-items-center">
                                                                <div className="pr-2 align-items-center"><EmailSubsectionChip className='icon-color-general-950' width={20} height={20}/></div>
                                                                <div className={"flex-grow-1 minw-0"}>
                                                                    <CustomTooltip
                                                                        text={t("email")}
                                                                        classes={`fs-14px ibl-font-w-600 font-color-general-950 text-ellipsis-1-row pt-1`}
                                                                        showIfTruncated={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-6 pr-0">
                                                            <CustomTooltip
                                                                text={item.email}
                                                                classes={"fs-14px font-color-shades-950 ibl-font-w-300 text-ellipsis-1-row text-end"}
                                                                showIfTruncated={true}
                                                                placement={"top"}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row d-flex justify-content-center align-items-center mt-3">
                                                        <div className="col-6 pl-0">
                                                            <div className="d-flex justify-content-start align-items-center">
                                                                <div className="pr-2 align-items-center"><PhoneSubsectionChip className='icon-color-general-950' width={20} height={20}/></div>
                                                                <div className={"flex-grow-1 minw-0"}>
                                                                    <CustomTooltip
                                                                        text={t("phone_number")}
                                                                        classes={`fs-14px ibl-font-w-600 font-color-general-950 text-ellipsis-1-row`}
                                                                        showIfTruncated={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-6 pr-0">
                                                            <CustomTooltip
                                                                text={item.phoneNumber}
                                                                classes={"fs-14px font-color-shades-950 ibl-font-w-300 text-ellipsis-1-row text-end"}
                                                                showIfTruncated={true}
                                                                placement={"top"}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </CustomCardGrid>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>

                        {pagination()}

                    </>
                    :
                    <NotInformation card={true}>
                        <>
                            <div className={"warning-text"}>
                                <p>{t("you_haven_not_created_any_contractor")}</p>
                            </div>
                            { (DEV || permission?.includes(permissionObj?.WEB_CONTRACTOR_CREATE)) &&
                                <CustomButtonLink
                                    splitName={false}
                                    id={'btn_cc_create'}
                                    card={true}
                                    onClick={() => navigate(routes.contractor.create)}
                                    name={'create_new_contractor'}
                                />
                            }
                        </>
                    </NotInformation>
            }
        </>
    );

}

export default ContractorsCards
